import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react'
import NumberFormat from 'react-number-format';
import { Card, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown } from 'reactstrap';

// HO-ISSUE-116: una alicuota no se puede eliminar. Se saco de aca la opcion
// "Eliminar" del menu y su modal de confirmacion, no se ocultaron.
//
// Borrar una alicuota no deja la alicuota en cero: deja a la unidad SIN fila en
// `aliquots`, y el reparto de gastos cruza esa tabla con un INNER JOIN, asi que
// esa unidad desaparece del reparto y deja de cobrarsele, en silencio. Para
// bajar cuanto paga una unidad esta "Editar"; para rehacer el reparto entero,
// la carga por Excel.
const AliquotListItem = ({
    name,
    amount,
    createdAt,
    options,
    handleEdit,
    specialAmount,
    onEditSpecial,
    property
}) => {

    return <>
        <Card className="shadow-none border-top mb-0" data-testid="AliquotItem">
            <CardHeader className="py-2 px-3">
                <Row className="align-items-center">
                    <Col>
                        <Row className="align-items-center">
                            <Col xs={12} md={6} className="d-flex align-items-center py-1">
                                <div className="media-body">
                                    <h6 className="mb-0 font-weight-semi-bold text-900 fs--1">
                                        {name.trim() !== "" ? name : "Propietario no registrado"}
                                    </h6>
                                    {property && (
                                        <div className="text-primary font-weight-bold fs--2 mt-1">
                                            <span className="text-500 font-weight-normal mr-1">Inmueble:</span>
                                            {property}
                                        </div>
                                    )}
                                </div>
                            </Col>
                            <Col xs={12} md={6} className="py-1">
                                <Row className="no-gutters justify-content-end">
                                    <Col xs="auto" className="px-3">
                                        <p className="text-right font-weight-bold mb-0 fs--2 text-500">Normal</p>
                                        <div className="text-right font-weight-bold fs--1">
                                            <NumberFormat
                                                suffix=' %'
                                                decimalScale={4}
                                                fixedDecimalScale={true}
                                                displayType='text'
                                                value={amount}
                                            />
                                        </div>
                                    </Col>
                                    <Col xs="auto" className="border-left pl-3">
                                        <div className="d-flex justify-content-end align-items-center">
                                            <p className="text-right font-weight-bold mb-0 mr-2 text-primary fs--2">Especial</p>
                                            {onEditSpecial && (
                                                <div
                                                    className="cursor-pointer text-primary"
                                                    onClick={(e) => { e.stopPropagation(); onEditSpecial(); }}
                                                    title="Editar Alícuota Especial"
                                                >
                                                    <FontAwesomeIcon icon="pencil-alt" size="xs" />
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-right text-primary font-weight-bold fs--1">
                                            {specialAmount !== undefined && specialAmount !== null ? (
                                                <NumberFormat
                                                    suffix=' %'
                                                    decimalScale={4}
                                                    fixedDecimalScale={true}
                                                    displayType='text'
                                                    value={specialAmount}
                                                />
                                            ) : (
                                                <span className="text-400 fs--2">--</span>
                                            )}
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                    {options &&
                        <Col xs="auto" className="d-flex align-items-center">
                            <UncontrolledDropdown direction="left" className="d-inline-block">
                                <DropdownToggle color="falcon-default" size="sm" className="btn-sm py-0 px-2">
                                    <FontAwesomeIcon icon="ellipsis-h" className="fs--2" />
                                </DropdownToggle>
                                <DropdownMenu right>
                                    <DropdownItem onClick={handleEdit} className="fs--1">Editar</DropdownItem>
                                </DropdownMenu>
                            </UncontrolledDropdown>
                        </Col>}
                </Row>
            </CardHeader>
        </Card>
    </>
}

export default AliquotListItem;